

// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});



// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

// 価格タブ切替は line-chart.js でブロック単位に処理するためここでは未定義
// （他のクリックリスナーとバッティングしないようイベント伝播は line-chart.js 側で止めています）

window.addEventListener('DOMContentLoaded', function(){

  // (1)パスワード入力欄とボタンのHTMLを取得
  let btn_passview = document.getElementById("btn_passview");
  let input_pass = document.getElementById("password");

	if (input_pass) {
		// (2)ボタンのイベントリスナーを設定
		btn_passview.addEventListener("click", (e) => {

			// (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
			e.preventDefault();

			// (4)パスワード入力欄のtype属性を確認
			if (input_pass.type === 'password') {

				// (5)パスワードを表示する
				input_pass.type = 'text';
				btn_passview.classList.add('invisible');
				btn_passview.classList.remove('visible');

			} else {

				// (6)パスワードを非表示にする
				input_pass.type = 'password';
				btn_passview.classList.add('visible');
				btn_passview.classList.remove('invisible');
			}
		});
	};

});

// ファイルアップロード
const input = document.getElementById('fileInput');
const fileName = document.getElementById('fileName');
const selectedBox = document.querySelector('.p-panelUpload__selected');
const importBtn = document.querySelector('.p-panelUpload__btn');
if (input) {
	// 初期状態
	fileName.textContent = '';
	selectedBox.style.display = 'none';

	input.addEventListener('change', function () {
		if (this.files && this.files.length > 0) {
			fileName.textContent = this.files[0].name;
			selectedBox.style.display = 'block';
			importBtn.style.display = 'flex';
		} else {
			fileName.textContent = '';
			selectedBox.style.display = 'none';
			importBtn.style.display = 'none';
		}
	});
}
